<template>
  <v-menu
    v-model="fromDateMenu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :label="label"
        :value="DateDisp"
        @change="$emit('input', $event.target.value)"
        v-on="on"
        readonly
      ></v-text-field>
    </template>
    <v-date-picker
      locale="fr-CA"
      v-model="dateVal"
      @change="emitDateVal"
      @input="fromDateMenu = false"
    ></v-date-picker>
  </v-menu>
</template>

<script>
const today = new Date();
const currentDate =
  today.getFullYear() +
  "-" +
  String(today.getMonth() + 1).padStart(2, "0") +
  "-" +
  String(today.getDate()).padStart(2, "0");

export default {
  props: ["label", "userDateVal"],
  data() {
    return {
      fromDateMenu: false,
      dateVal: currentDate,
      value: null,
    };
  },
  computed: {
    DateDisp() {
      if (!this.dateVal) return null;

      const [year, month, day] = this.dateVal.split("-");

      return `${day}/${month}/${year}`;
    },
  },
  methods: {
    // emitDateVal() {
    //   this.$emit("getDateVal", this.DateDisp);
    // },
    emitDateVal() {
      this.$emit("getDateVal", this.dateVal);
    },
  },
};
</script>
